import { RouteLocationNormalizedGeneric } from 'vue-router';
import { SeoData } from './useMeta.ts';

import { useCollectionStore } from '@/features/Collection/stores/collection.ts';
import { usePageStore } from '@/features/Page/stores/page.ts';
import { useProductCompleteStore } from '@/features/Product/stores/productComplete.ts';

const validHandle = (handle: unknown): string =>
  handle && typeof handle === 'string' ? handle : handle[0];

export const findRouteSeo = (route: RouteLocationNormalizedGeneric): SeoData => {
  const { findCollectionByHandle } = useCollectionStore();
  const { getCompleteProduct } = useProductCompleteStore();
  const { findPageByHandle } = usePageStore();
  const { name, params } = route;
  const { handle, parentHandle } = params;
  try {
    const routeHandle = handle || parentHandle;
    if (name === 'collection' && validHandle(routeHandle)) {
      const formattedHandle = validHandle(routeHandle);
      const collection = findCollectionByHandle(formattedHandle);
      if (!collection) return;
      return {
        ...collection.seo,
        path: route.fullPath,
      };
    } else if ((name === 'product' || name === 'product-contextual') && validHandle(routeHandle)) {
      const formattedHandle = validHandle(routeHandle);
      const product = getCompleteProduct('attributes.handle', formattedHandle);
      if (!product) return;
      return {
        ...product.seo,
        path: route.fullPath,
      };
    } else if (name === 'page' && validHandle(handle)) {
      const formattedHandle = validHandle(handle);
      const page = findPageByHandle(formattedHandle);
      if (!page) return;
      return {
        ...page.seo,
        path: route.fullPath,
      };
    } else if (name === 'account') {
      return {
        title: 'Accounts',
        description: `Access all of Hismile's benefits`,
        path: route.fullPath,
      };
    }
  } catch (error) {
    console.log(error);
    return {
      title: '',
      description: '',
      path: '',
    };
  }
};
